var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.59723 0 0 3.10042 0 6.93302L0.00309658 7.12677C0.118421 10.7235 3.44107 13.2643 7.64986 13.3178L7.92 13.3175V15.2715C7.92 15.8545 8.63672 16.2005 9.16801 15.874L10.2768 15.1927C11.1928 14.6294 12.2517 13.8268 13.2383 12.8115C14.7574 11.2481 15.7454 9.52524 15.9555 7.66439C15.9847 7.41223 16 7.17069 16 6.93302C16 3.10042 12.4028 0 8 0ZM8 1.45443C11.5376 1.45443 14.4 3.92151 14.4 6.93302C14.4 7.11714 14.3879 7.30838 14.3641 7.51404C14.1924 9.03445 13.3554 10.4939 12.0391 11.8487L11.7957 12.0928C11.061 12.8114 10.2909 13.4036 9.60561 13.846L9.52 13.8993V12.5478C9.52 12.117 9.11023 11.7806 8.63871 11.8244C4.70921 12.1892 1.6 10.035 1.6 6.93302C1.6 3.92151 4.46239 1.45443 8 1.45443Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment-icon.86e830b1cc3fdf85cd1141e5219c54d4.svg";
export { ForwardRef as ReactComponent };